<div class="holder">
    <roots-page-header
      title="Dashboard"
      toolTip="Manage scouts logs, widgets, and other helpful tools from the dashboard. Providing convenience of use tools across global app functions"
      [loading]="false">
    </roots-page-header>
    <div class="container data-wrapper gray" style="height: 90vh; max-width: 100%;">
      <dashboard [dashboardId]="dashboardId"></dashboard>
      <!-- <app-scout-logs [logs]="logs" [loading]="loading" ></app-scout-logs> -->
      <!-- style="overflow: auto;  max-height: 25em;" -->
    </div>
  </div>